module.exports = __webpack_public_path__ + "static/media/choke.f2809682.png";